import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Container, styled, useMediaQuery, useTheme } from '@mui/material';

import images from 'assets/images';

const StyledHeader = styled(Box)(({ matchUpSm }) => ({
	position: 'relative',
	height: matchUpSm ? '750px' : '420px',
	backgroundImage: `url(${images.CoogoongKvBg})`,
	backgroundSize: 'cover',
	backgroundPosition: 'center',
	backgroundRepeat: 'no-repeat',
	backgroundColor: '#000000'
}));

const StyledContainer = styled(Container)(() => ({}));

const BrandLogo = ({ onClick }) => {
	return (
		<Box
			display={'flex'}
			alignItems={'center'}
			sx={{ cursor: 'pointer' }}
			onClick={onClick}
		>
			<img
				src={images.CoogoongNaviLogo}
				alt={'coogoong'}
				height={32}
				style={{ objectFit: 'contain', display: 'block' }}
			/>
		</Box>
	);
};

const Header = () => {
	const theme = useTheme();
	const matchUpSm = useMediaQuery(theme.breakpoints.up('sm'));

	const { pathname } = useLocation();
	const navigate = useNavigate();

	const handleMoveRoot = () => {
		navigate('/');
	};

	if (pathname === '/') {
		return (
			<StyledHeader component={'header'} matchUpSm={matchUpSm}>
				<StyledContainer maxWidth={'lg'} sx={{ position: 'relative', zIndex: 2 }}>
					<Box py={'25px'} px={matchUpSm ? '25px' : '20px'}>
						<BrandLogo onClick={handleMoveRoot} />
					</Box>
				</StyledContainer>
				{/* KV 텍스트: 영역 기준 상하·좌우 정중앙 */}
				<Box
					sx={{
						position: 'absolute',
						inset: 0,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						pointerEvents: 'none',
						zIndex: 1,
						px: matchUpSm ? 4 : 2
					}}
				>
					<img
						src={images.CoogoongKvText}
						alt={"Discover What's New, coogoong"}
						style={{
							width: matchUpSm ? 'min(520px, 55%)' : 'min(280px, 78%)',
							height: 'auto',
							objectFit: 'contain'
						}}
					/>
				</Box>
			</StyledHeader>
		);
	}

	return (
		<Box bgcolor={'#000000'}>
			<StyledContainer maxWidth={'lg'}>
				<Box py={'25px'} px={matchUpSm ? '25px' : '20px'}>
					<BrandLogo onClick={handleMoveRoot} />
				</Box>
			</StyledContainer>
		</Box>
	);
};

export default Header;
